export default __webpack_public_path__ + "static/media/not.49a5fd04.png";